(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("sbCasinoSlimSdk", [], factory);
	else if(typeof exports === 'object')
		exports["sbCasinoSlimSdk"] = factory();
	else
		root["sbCasinoSlimSdk"] = factory();
})(window, function() {
return 